<template>
  <LayoutTelas
    id="tela__ligacoes"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <BTable
      stacked="sm"
      striped
      :items="listaLigacoes"
      :fields="retornaCamposMostrarTabela()">

      <template
        slot="whatsapp"
        slot-scope="data">
        <BButton
          size="sm"
          @click="abrirWhatsApp(data.item.contato)"
          variant="success">
          <v-icon
            scale="1.3"
            name="whatsapp"
            class="iconButton"/>
        </BButton>
      </template>

      <template
        slot="contatoRealizado"
        slot-scope="data">
        <BButton
          size="sm"
          @click="confirmaLigacaoIndicacao(data)"
          variant="success">
          <v-icon
            scale="1.3"
            name="check"
            class="iconButton"/>
        </BButton>
      </template>
      <template
        slot="contatoSemInteresse"
        slot-scope="data">
        <BButton
          size="sm"
          @click="indicacaoSemInteresse(data)"
          variant="danger">
          <v-icon
            scale="1.3"
            name="times"
            class="iconButton"/>
        </BButton>
      </template>
    </BTable>

    <div class="paginacao"
      v-if="paginacao.totalPaginas > 1">
      <b-pagination
        :total-rows="paginacao.limitePorPagina * paginacao.totalPaginas"
        :per-page="paginacao.limitePorPagina"
        v-model="paginacao.paginaAtual"
        @input="mudarPagina"
        size="sm"
        class="paginacao__seletor" />
    </div>

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      main-icon="add"
      :start-opened="true"
      @atualizar="mudarPagina" />

    <ModalConfirmacao
      ref="modalConfirmacao"
      titulo="Contato com indicação"
      :mensagem="mensagemConfirmacao"
    />
  </LayoutTelas>
</template>

<script>
import moment from 'moment-timezone'
import fab from 'vue-fab'
import { BTable, BButton, BPagination } from 'bootstrap-vue/es/components'
import GeradorMensagens from '@/mixins/GeradorMensagens'
import indicacoesService from '../../services/indicacoes.service'

import ModalConfirmacao from '@/components/modal/ModalConfirmacao.vue'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'atualizar',
      icon: 'sync',
      tooltip: 'Atualizar',
    },
  ],
}

export default {
  name: 'Ligacoes',
  mixins: [GeradorMensagens],
  components: {
    BTable,
    BButton,
    BPagination,
    fab,
    ModalConfirmacao,
  },
  data() {
    return {
      mensagemConfirmacao: '',
      floatButton: botaoFlutuante,
      listaLigacoes: [],
      isLoading: false,
      paginacao: {
        paginaAtual: 0,
        totalPaginas: 0,
        limitePorPagina: 20,
      },
    }
  },
  mounted() {
    this.carregar()
  },
  methods: {
    retornaCamposMostrarTabela() {
      return [
        { key: 'nome', label: 'Nome' },
        { key: 'contato', label: 'Contato' },
        { key: 'whatsapp', label: '' },
        { key: 'barbeiro', label: 'Barbeiro' },
        { key: 'filial', label: 'Filial' },
        { key: 'contatoRealizado', label: '' },
        { key: 'contatoSemInteresse', label: '' },
      ]
    },
    mostrarLoading(mostrar = true) {
      this.isLoading = mostrar
    },
    async carregar(pagina = 0) {
      try {
        this.mostrarLoading()
        this.listaLigacoes = []
        const filialAtual = this.$store.getters['autenticacao/userObj'].usuario.filial._id
        const retorno = await indicacoesService.retornaAguardandoContato(filialAtual, pagina)

        this.listaLigacoes = retorno.lista
        this.paginacao.totalPaginas = retorno.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoading(false)
      }
    },
    async confirmaLigacaoIndicacao(indicacao) {
      this.mensagemConfirmacao = 'Confirmar que a indicação possui interesse?'
      const podeConcluir = await this.$refs.modalConfirmacao.pop()
      if (podeConcluir) {
        try {
          this.mostrarLoading()
          const ind = this.retornaObjLigacaoConcluida(indicacao.item, true, true)
          const retorno = await indicacoesService.atualizar(ind)

          this._removerItemDaLista(indicacao.index)
          this.tratarRespostaMsg(retorno)
        } catch (error) {
          this.tratarRespostaMsg(error)
        } finally {
          this.mostrarLoading(false)
        }
      }
    },
    async indicacaoSemInteresse(indicacao) {
      this.mensagemConfirmacao = 'Deseja realmente remover a indicação?'
      const podeConcluir = await this.$refs.modalConfirmacao.pop()
      if (podeConcluir) {
        try {
          this.mostrarLoading()
          const ind = this.retornaObjLigacaoConcluida(indicacao.item, true, false)
          const retorno = await indicacoesService.atualizar(ind)

          this._removerItemDaLista(indicacao.index)
          this.tratarRespostaMsg(retorno)
        } catch (error) {
          this.tratarRespostaMsg(error)
        } finally {
          this.mostrarLoading(false)
        }
      }
    },
    mudarPagina() {
      this.carregar(this.paginacao.paginaAtual)
    },
    retornaObjLigacaoConcluida(indicacao, entrouContato, temInteresse) {
      const objInd = Object.assign({}, indicacao)
      objInd.dataContato = moment.tz(this.value, 'America/Sao_Paulo')._d
      objInd.entrouContato = entrouContato
      objInd.temInteresse = temInteresse
      return objInd
    },
    _removerItemDaLista(indice) {
      this.listaLigacoes.splice(indice, 1)
    },
    abrirWhatsApp(contato) {
      if (contato) {
        const numero = contato.replace(/\D/g, '')
        window.open(`https://api.whatsapp.com/send?phone=${numero}`, '_blank')
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__ligacoes {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

.paginacao {
  display: flex;
  justify-content: flex-end;

  &__seletor {
    margin: 0;
  }
}

</style>
